import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing, getPurpurTypography } from '@telialt/common-theme/src/purpurSelectors';

export const StyledSectionQuote = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('250')};
    padding: ${getPurpurSpacing('200')} ${getPurpurSpacing('250')};
`;

export const QuoteContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('150')};

    [class^='_purpur-paragraph'] {
        font-weight: ${getPurpurTypography('weightBold')};
        line-height: ${getPurpurTypography('lineHeightLoose')};
    }
`;

export const QuoteAuthor = styled.div`
    line-height: ${getPurpurTypography('lineHeightLoose')};
    color: ${getPurpurColor('textMedium')};
    font-size: ${getPurpurTypography('scale75')};
`;

export const QuoteIcon = styled.div`
    color: ${getPurpurColor('purple700')};
`;
